import _BaseAPIService from "../_BaseAPIService";

const slug = "coopteam";

const api_Service = _BaseAPIService.instance;
const user = JSON.parse(localStorage.getItem("user"));
  const coopId = user?.user?.cooperative_id;

const CoopteamService = {
  get: async () => {
    const response = await api_Service.get(`/${slug}/getlist/${coopId}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api_Service.get(`/${slug}/${id}`);
    return response.data;
  },
  update: async (coopTeamId, data) => {
    const response = await api_Service.put(`/${slug}/${coopTeamId}`, data);
    return response.data;
  },
  create:async(data)=>{
    const response=await api_Service.post(`/${slug}`,data);
    return response.data;
  },
  delete:async(id)=>{
    const response= await api_Service.delete(`/${slug}/${id}`);
    return response.data;
  }
};

export default CoopteamService;
